import { render, staticRenderFns } from "./BookPage.vue?vue&type=template&id=593556a2&"
import script from "./BookPage.vue?vue&type=script&lang=ts&"
export * from "./BookPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports